"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnerData = void 0;
const react_query_1 = require("react-query");
const graphql_request_1 = require("graphql-request");
function pruneOpeningHours(openingHours) {
    var _a;
    if (openingHours === undefined) {
        return openingHours;
    }
    // RegEx to validate time string in format HH:MM:SS (00:00:00 - 23:59:59)
    const timeRegEx = /^([0-1][0-9]|2[0-3]){1}(:[0-5][0-9]){1,2}$/g;
    const departments = (_a = openingHours === null || openingHours === void 0 ? void 0 : openingHours.departments) === null || _a === void 0 ? void 0 : _a.filter((department) => {
        if (department.openingHours && department.openingHours.length > 0) {
            return department.openingHours.every((openingHour) => {
                if (openingHour.timeRanges && openingHour.timeRanges.length > 0) {
                    return openingHour.timeRanges.every((timeRange) => {
                        var _a, _b;
                        if (((_a = timeRange.openTime) === null || _a === void 0 ? void 0 : _a.match(timeRegEx)) === null ||
                            ((_b = timeRange.closeTime) === null || _b === void 0 ? void 0 : _b.match(timeRegEx)) === null) {
                            // eslint-disable-next-line no-console
                            console.debug(`Detected wrong format in department opening times! Department is filtered out.\nAffected department: ${department.id ? department.id : department.departmentName}\nEntry: ${openingHour.id}`);
                            return false;
                        }
                        return true;
                    });
                }
                return true;
            });
        }
        return true;
    });
    return Object.assign(Object.assign({}, openingHours), { departments });
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const usePartnerData = (partnerId, endpoint, locale, queryString) => {
    const client = new graphql_request_1.GraphQLClient(endpoint, {
        headers: {
            clientId: "dg552wqh5t",
            translation: locale,
        },
    });
    const gqlQuery = (0, graphql_request_1.gql) `
    ${queryString(partnerId)}
  `;
    return (0, react_query_1.useQuery)(["DealerById", partnerId, endpoint, locale], async () => {
        const { dealerById } = await client.request(gqlQuery);
        if (dealerById.openingHours) {
            dealerById.openingHours = pruneOpeningHours(dealerById.openingHours);
        }
        return dealerById;
    }, {
        enabled: !!partnerId && !!endpoint,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
};
exports.usePartnerData = usePartnerData;
//# sourceMappingURL=use-partner-data.js.map